import { createContext } from 'react';

const DataImportContext = createContext(null);

export { DataImportContext };
